// @flow
export { default } from './Modal';
export { ModalPortal } from './ModalPortal';



// WEBPACK FOOTER //
// ./src/components/Modal/index.js